import React from "react";
import ChartCard from "../../components/Cards/ChartCard";
import TotalRevenueChart from "./Charts/TotalRevenueChart";
import TotalSalesByCategoryChart from "./Charts/TotalSalesByCategoryChart";
import { useSelector } from "react-redux";

const user = JSON.parse(localStorage.getItem("user"));

export default function DashboardCharts(props) {
  const { statistics, loading } = useSelector((state) => state.Dashboard);

  return (
    <>
      <div className="row">
        <ChartCard
          label="Orders Value (JOD)"
          description="Total Orders Value"
          value={statistics?.ordersValue?.total_orders_revenue?.toFixed(3) || 0}
          loading={loading}
          cardWidth={3}
          className="text-center"
        />

        <ChartCard
          label="Completed Orders"
          description="Total completed orders"
          value={statistics?.completedOrders?.total_completed_orders_count || 0}
          loading={loading}
          cardWidth={3}
          className="text-center"
        />

        <ChartCard
          label="Monthly Sales (JOD)"
          description="Total Monthly Sales"
          value={
            statistics?.revenueThisMonth?.total_orders_revenue?.toFixed(3) || 0
          }
          loading={loading}
          cardWidth={3}
          className="text-center"
        />

        <ChartCard
          label={
            user?.role == 1
              ? "Supplier Commission (JOD)"
              : "Pillvery Commission (JOD)"
          }
          description={
            user?.role == 1
              ? "Total Supplier Commission"
              : "Total Pillvery Commission"
          }
          value={
            statistics?.pillveryCommission2?.completed_orders?.total_pillvery_commission?.toFixed(
              3
            ) || 0
          }
          loading={loading}
          cardWidth={3}
          className="text-center"
        />
      </div>

      <div className="row">
        <ChartCard
          label="Total Daily Revenue (JOD)"
          chart={<TotalRevenueChart />}
          cardWidth={8}
          loading={loading}
        />
        <ChartCard
          label="Total Sales By Category"
          chart={<TotalSalesByCategoryChart />}
          cardWidth={4}
          loading={loading}
        />
      </div>
    </>
  );
}
